import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent }
	from './login/forgot-password.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { LoginLegacyComponent } from './login/login-legacy.component';
import { ConfirmPasswordLegacyComponent } from './login/confirm-password-legacy.component';
import { SelectVisibilityComponent } from './login/visibility/select-visibility.component';
import { SelectOrgaVisibilityComponent } from './login/visibility/select-orga-visibility.component';
import { NoVisibilityAccessComponent } from './login/visibility/no-visibility-access.component';
import { ValidateUserComponent } from './login/validate-user.component';
import { ChangeUserEmailComponent } from './email/change-user-email.component';

const rootRoutes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full'
	},
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'forgot-password',
		component: ResetPasswordComponent
	},
	{
		path: 'select-visibility',
		component: SelectVisibilityComponent
	},
	{
		path: 'select-orga-visibility',
		component: SelectOrgaVisibilityComponent
	},
	{
		path: 'no-visibility-access',
		component: NoVisibilityAccessComponent
	},
	{
		path: 'login-legacy',
		component: LoginLegacyComponent
	},
	{
		path: 'confirm-password-legacy',
		component: ConfirmPasswordLegacyComponent
	},
	{
		path: 'validate-user',
		component: ValidateUserComponent
	},
	{
		path: 'change-mail',
		component: ChangeUserEmailComponent
	},
	{
		path: 'reset-password',
		component: ValidateUserComponent
	},
	{
		path: 'expired-password',
		component: ValidateUserComponent
	},
	{
		path: '**', component: NotFoundComponent
	}
];

export const routing = RouterModule.forRoot(rootRoutes);
